const mEditionAcademyUsersDropDownFilters = {
  mEditionAcademyUsersDropDownFilters: {
    input: {
      actor: {
        label: 'Rol de Usuario'
      },

      email: {
        label: 'Email',
        placeholder: 'usuario@email.com'
      },

      estado: {
        label: 'Estado de Acceso'
      },

      fecha: {
        label: 'Fecha de Alta',
        desde: {
          placeholder: 'Desde - DD MM, AAAA'
        },

        hasta: {
          placeholder: 'Hasta - DD MM, AAAA'
        }
      },

      nombre: {
        label: 'Nombre o Razón Social'
      },

      pais: {
        label: 'País',
        firstOption: 'Todos los países'
      }
    },

    buttons: {
      reload: 'ACTUALIZAR',
      search: 'FILTRAR'
    }
  }
}

export default mEditionAcademyUsersDropDownFilters
